import { EventDoc } from 'types/api/changes'
import { CurrentConvertedCalendars } from './google_events'
import { icloudPrefix } from 'components/providers/icloud/IcloudProvider'

export function thirdPartyCalendarIdToPrimaryEmail(id: string): string {
  return (
    CurrentConvertedCalendars.find((calendar) => calendar.id === id)
      ?.primaryCalendarEmail || ''
  )
}

export function isIcloudEvent(event: EventDoc) {
  return event.GroupID?.includes(icloudPrefix)
}
